import { FormEvent, useContext, useEffect, useState } from 'react'
import { FaTasks } from "react-icons/fa"
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import avatarDefault from "../../assets/img/avatarDefault.png"
import apagarImg from '../../assets/img/excluir.png'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { ProcessosContext } from '../../contexts/Processos'
import { criptografarDado, descriptografarDado } from '../../helpers'
import { MembroProjeto } from '../../interfaces/projetos'
import { cadastrarSubTarefaLocal, subTarefasResposta } from '../../interfaces/subTarefas'
import { anexosListaResposta, comentariosListaResposta, ModalTarefasDados } from '../../interfaces/tasks'
import { buscarEtapaController, deletarBacklog, listarMembrosProjeto } from '../../services/projetos'
import { atualizarSubTarefa, deletarSubTarefa, listarSubtarefas, novaSubTarefa } from '../../services/subTarefas'
import { anexarArquivo, atualizarTarefa, buscarAnexos, deletarAnexo, listarComentarios, novaTarefa, postarComentario } from '../../services/tasks'
import '../../styles/modal.css'
import { Button, Loader } from '../Styles'
import './tarefas.css'

function ModalTarefas({ tarefa, backlog, idEtapa }: ModalTarefasDados) {
    const { search, pathname } = useLocation()

    const { atualizarDados, atualizarInformacoes, modalExibir } = useContext(ModalEstadoContext)
    const { atualizarDadosProcesso } = useContext(ProcessosContext)

    const paramsUrl = new URLSearchParams(search)

    const idProjeto = paramsUrl.get("idProjeto")

    const [tipo, setTipo] = useState(tarefa?.tipo)
    const [prioridade, setPrioridade] = useState(tarefa?.prioridade)
    const [situacao, setSituacao] = useState(tarefa?.situacao)
    const [titulo, setTitulo] = useState(tarefa?.titulo || backlog?.titulo)
    const [descricao, setDescricao] = useState(tarefa?.descricao || backlog?.descricao)
    const [responsavel, setResponsavel] = useState(tarefa?.idResponsavel || tarefa?.usuarioResponsavel.id)
    const [resposaveis, setResponsaveis] = useState<MembroProjeto[]>([])
    const [dataEntrega, setDataEntrega] = useState(tarefa?.dataEntrega)
    const [resultado, setResultado] = useState(tarefa?.resultado)
    const [automacao, setAutomacao] = useState<boolean>(!!tarefa?.automacao)
    const [recorrencia, setRecorrencia] = useState<string | null | undefined>(tarefa?.recorrencia)
    const [recorrenciaDia, setRecorrenciaDia] = useState<string | number | undefined | null>(tarefa?.recorrenciaDia)
    const [recorrenciaMes, setRecorrenciaMes] = useState<string | number | undefined | null>(tarefa?.recorrenciaMes)
    const [prazo, setPrazo] = useState(tarefa?.prazo)
    const [inicioAutomacao, setInicioAutomacao] = useState(tarefa?.inicioAutomacao)
    const [subTarefas, setSubtarefas] = useState<subTarefasResposta[]>([])
    const [subTarefasLocal, setSubTarefasLocal] = useState<cadastrarSubTarefaLocal[]>([])
    const [arquivo, setArquivo] = useState<File | null>(null)
    const [comentario, setComentario] = useState<string | null>(null)
    const [comentarios, setComentarios] = useState<comentariosListaResposta[]>([])
    const [anexos, setAnexos] = useState<anexosListaResposta[]>([])
    const [opcoesTarefas, setOpcoesTarefas] = useState('descricao')
    const [processando, setProcessando] = useState(false)
    const [ultimaEtapa, setUltimaEtapa] = useState(0)
    const [idUsuarioAprovador, setIdUsuarioAprovador] = useState(tarefa?.idUsuarioAprovador ?? null);
    const perfilGesttor = localStorage.getItem('perfilGesttor')
    const perfilLogado = perfilGesttor && descriptografarDado(perfilGesttor)
    const usuarioLogado = localStorage.getItem('usuarioGesttor')

    const exibirOpcoestarefas = (opcao: string) => {

        const opcoes = Array.from(document.querySelectorAll('.opcoesTarefasLabel'))

        opcoes.forEach((label) => {
            label.addEventListener('click', () => {

                opcoes.forEach((element) => {
                    element.classList.remove('labelOpcoesTarefaAtiva')
                })

                label.classList.add('labelOpcoesTarefaAtiva')

            })
        })

        return setOpcoesTarefas(opcao)
    }

    const cadastrarNovaSubTarefa = async () => {

        setProcessando(true)

        const descricaoSubTarefa = window.prompt('Insira sua Subtarefa')

        if (tarefa?.id === null || descricaoSubTarefa === null) {
            return setProcessando(false)
        }

        try {

            const payload = {
                descricao: descricaoSubTarefa
            }

            const resposta = await novaSubTarefa(Number(tarefa?.id), payload)

            if (resposta.status === 201) {
                setProcessando(false)
                atualizarDados()
                atualizarDadosProcesso()


                return toast.success("SubTarefa Cadastrado com Sucesso.")
            }

        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao Cadastrar SubTarefa")
        }
    }

    function ocultarModal() {
        return modalExibir("")
    }

    const documentoSelecionado = (e: any) => {

        const arquivo = e.target.files[0]

        return setArquivo(arquivo)
    }


    const visualizarAnexoTarefa = async (url: string) => {

        setProcessando(true)

        try {

            const baixarAnexo = await fetch(url)

            const blob = await baixarAnexo.blob()

            const anexo = URL.createObjectURL(blob)

            const link = document.createElement('a')

            link.href = anexo

            link.download = `${nomeArquivo(url)}`

            document.body.appendChild(link)

            link.click()

            document.body.removeChild(link)

            return setProcessando(false)

        } catch (error) {

            setProcessando(false)

            return alert('Falha ao Baixar o Arquivo')

        }

    }

    const cadastrarTarefa = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando(true)

        if (!idProjeto) return toast.error("Não foi possivel cadastrar a tarefa, pois o projeto não foi encontrado.")

        const idProjetoDescript = descriptografarDado(idProjeto)

        if (automacao === undefined || !idProjetoDescript) {
            setProcessando(false)
            return
        }

        try {

            const payload = {
                idResponsavel: responsavel,
                idUsuarioAprovador,
                titulo,
                descricao,
                dataEntrega,
                prioridade,
                tipo,
                idProjeto: idProjetoDescript,
                idEtapa,
                automacao,
                recorrencia,
                recorrenciaDia,
                recorrenciaMes,
                prazo,
                inicioAutomacao
            }

            if (subTarefasLocal.length > 0) {
                Object.assign(payload, {
                    subtarefas: subTarefasLocal
                })
            }

            const resposta = await novaTarefa(payload)

            if (backlog) {
                const idBacklogCript = criptografarDado(backlog.id.toString())
                await deletarBacklog(idBacklogCript)
            }

            if (resposta.status === 201) {
                setProcessando(false)
                atualizarDados()
                toast.success("Tarefa Cadastrada com Sucesso.")
                modalExibir("")
            }

        } catch (error) {
            setProcessando(false)
            toast.error("Erro ao Cadastrar Tarefa.")
        }

    }

    const enviarComentario = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando(true)

        if (!tarefa) {
            return;
        }

        if (comentario === null) {
            setProcessando(false)
            return alert('Preencha o Comentário')
        }

        try {

            const payload = {
                comentario
            }

            const resposta = await postarComentario(tarefa.id.toString(), payload)

            if (resposta.status === 201) {
                setProcessando(false)
                atualizarDados()
                toast.success("Comentario Enviado com Sucesso.")
            }

        } catch (error) {
            setProcessando(false)
            toast.error("Erro ao Enviar o Comentario.")
        }

    }

    const anexarDocumento = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando(true)

        if (!tarefa) {
            return;
        }

        if (arquivo === null) {
            setProcessando(false)
            return alert('Nenhum Arquivo Anexado')
        }

        try {

            const payload = {
                arquivo
            }

            const resposta = await anexarArquivo(tarefa.id.toString(), payload)

            if (resposta.status === 201) {
                setProcessando(false)
                atualizarDados()
                toast.success("Documento Anexado com Sucesso.")
            }

        } catch (error) {
            setProcessando(false)
            toast.error("Erro ao Anexar Documento.")
        }

    }

    const apagarAnexo = async (e: FormEvent, idAnexo: string) => {

        e.preventDefault()
        setProcessando(true)

        try {

            const resposta = await deletarAnexo(idAnexo)

            if (resposta.status === 200) {
                setProcessando(false)
                atualizarDados()
                toast.success("Anexo Excluido com Sucesso.")
            }

        } catch (error) {
            setProcessando(false)
            toast.error("Erro ao Excluir Anexo.")
        }

    }

    const nomeArquivo = (url: string) => {

        const nomeArray = url.split('/')

        const nomeNumero = nomeArray[nomeArray.length - 1].split('.')

        const nome = nomeNumero.slice(1).join('')

        return nome
    }

    const updateTarefa = async (e: FormEvent) => {
        e.preventDefault()
        setProcessando(true)

        if(idUsuarioAprovador !== null && idUsuarioAprovador !== usuarioLogado && tarefa?.situacao !== "concluída" && situacao === "concluída"){
            setProcessando(false)
            return toast.warn("Você não tem permissão para finalizar esta tarefa.")
        }

        if (!tarefa?.id || responsavel === undefined || titulo === undefined || descricao === undefined || dataEntrega === undefined || prioridade === undefined || tipo === undefined || automacao === undefined || recorrencia === undefined || resultado === undefined || recorrenciaDia === undefined || recorrenciaMes === undefined || prazo === undefined || situacao === undefined) {
            return setProcessando(false)
        }

        if (situacao === 'concluída' && resultado === null) {
            toast.warning('A tarefa não pode ser finalizada sem um resultado')

            return setProcessando(false)
        }

        const conclusaoSubTarefas = subTarefas.some(subtarefa => subtarefa.finalizada === false)

        if (conclusaoSubTarefas && situacao === 'concluída') {
            
            toast.warning('A tarefa não pode ser finalizada com subtarefas pendentes')
            return setProcessando(false)
        }

        const payload = {
            idResponsavel: responsavel,
            idUsuarioAprovador: idUsuarioAprovador || null,
            titulo,
            descricao,
            prioridade,
            tipo,
            dataEntrega,
            automacao,
            inicioAutomacao,
            recorrencia,
            recorrenciaDia,
            recorrenciaMes,
            prazo,
            resultado,
            situacao
        }

        try {

            const resposta = await atualizarTarefa(tarefa.id.toString(), payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success("Tarefa Atualizada com Sucesso.")
                atualizarDados()
                atualizarDadosProcesso()
                modalExibir("")
            }

        } catch (error) {

            setProcessando(false)
            toast.error("Erro ao Atualizar Tarefa.")

            return
        }
    }

    const updateSubTarefa = async (idSubTarefa: number, finalizada: boolean) => {

        setProcessando(true)

        try {

            const payload = {
                finalizada: !finalizada
            }

            const resposta = await atualizarSubTarefa(idSubTarefa, payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success("Sub Tarefa Atualizada com Sucesso.")
                atualizarDados()
                atualizarDadosProcesso()
            }

        } catch (error) {
            setProcessando(false)
            toast.error("Erro ao Atualizar Sub Tarefa.")
        }
    }

    const deleteSubTarefa = async (idSubTarefa: number) => {

        setProcessando(true)

        try {
            const resposta = await deletarSubTarefa(idSubTarefa)

            if (resposta.status === 200) {
                setProcessando(false)
                atualizarDados()
                atualizarDadosProcesso()
                toast.success("SubTarefa Deletado com Sucesso.")
            }

        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao Deletar SubTarefa.")
        }
    }

    const adicionarSubTarefaLocal = () => {

        const subTarefaLocal = window.prompt('Insira sua Subtarefa')

        if (subTarefaLocal === null) {
            return
        }

        const subTarefa = {
            descricao: subTarefaLocal
        }

        return setSubTarefasLocal(itens => [...itens, subTarefa])
    }

    const removerSubTarefaLocal = (posicao: number) => {

        setSubTarefasLocal(itens => [...itens])

        return subTarefasLocal.splice(posicao, 1)
    }

    useEffect(() => {

        if (recorrencia === 'semanal' && inicioAutomacao !== undefined && inicioAutomacao !== null) {

            const diaAnterior = new Date(inicioAutomacao)

            const dia = new Date(diaAnterior.setDate(diaAnterior.getDate() + 1))

            setRecorrenciaDia(dia.getDay())

        }

        if ((recorrencia === "mensal" || recorrencia === 'trimestral' || recorrencia === "semestral" || recorrencia === "anual") && inicioAutomacao !== undefined && inicioAutomacao !== null) {

            const data = new Date(inicioAutomacao)

            const dia = new Date(data.setDate(data.getDate() + 1))

            setRecorrenciaDia(dia.getDate())

        }

        if ((recorrencia === "anual" || recorrencia === 'trimestral' || recorrencia === "semestral") && inicioAutomacao !== undefined && inicioAutomacao !== null) {

            const data = new Date(inicioAutomacao)

            const mes = new Date(data.setMonth(data.getMonth() + 1))

            setRecorrenciaMes(mes.getMonth())

        }

    }, [recorrencia, inicioAutomacao])

    useEffect(() => {
        const listarMembrosResponsaveis = async () => {
            if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

            try {
                const idProjetoEncoded = encodeURIComponent(idProjeto)
                const resposta = await listarMembrosProjeto(idProjetoEncoded);
                setResponsaveis(resposta.data);
            } catch (error) {
                toast.error("Erro ao listar todos os membros do Projeto.");
            }
        };
        listarMembrosResponsaveis()

    }, [idProjeto])

    useEffect(() => {

        const buscarSubTarefas = async () => {

            if (tarefa?.id === null || tarefa?.id === undefined) {
                return
            }

            try {

                const resposta = await listarSubtarefas(tarefa.id.toString())

                if (resposta.status === 200) {
                    setSubtarefas(resposta.data)
                }

            } catch (error) {
                toast.error("Erro ao listar subTarefas.")
            }
        }

        buscarSubTarefas()

    }, [atualizarInformacoes, tarefa?.id])

    useEffect(() => {

        const anexosTarefas = async () => {

            if (!tarefa) {
                return;
            }

            try {

                const requsicoes = [
                    buscarAnexos(tarefa.id.toString()),
                    listarComentarios(tarefa.id.toString())
                ]

                const resposta = await Promise.all(requsicoes)

                const anexos = resposta[0]
                const comentarios = resposta[1]

                if (anexos.status === 200) {
                    setAnexos(anexos.data)
                }

                if (comentarios.status === 200) {
                    setComentarios(comentarios.data)
                }

            } catch (error) {

            }
        }

        anexosTarefas()

    }, [atualizarInformacoes, search, tarefa])

    useEffect(() => {
        const buscarUltimaEtapa = async () => {
            if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")
            try {
                const resposta = await buscarEtapaController(idProjeto)
                if (resposta.status === 200 && resposta.data != null) {
                    setUltimaEtapa(resposta.data.id)
                }
            } catch (error) {
                toast.error("Não foi possivel Buscar a Ultima Etapa do Projeto.")
            }
        }
        buscarUltimaEtapa()
    }, [idProjeto])

    return (
        <div id='fundoModal'>
            <section className={tarefa && pathname.startsWith("/indicadores") ? 'containerModalCentro' : 'containerModalCentro'}>
                <span id='novoContainerTitulo'>
                    <FaTasks fontSize={"30px"} />
                    <p>{!tarefa ? 'Nova Tarefa' : 'Vizualizar Tarefa'}</p>
                </span>
                <form id='formModalNovo' onSubmit={tarefa ? updateTarefa : cadastrarTarefa}>
                    <section>
                        <span>
                            <label htmlFor="tipoNovaTarefa">Tipo</label>
                            <select id='tipoNovaTarefa' value={tipo} onChange={(e) => setTipo(e.target.value)} required>
                                <option value=""></option>
                                <option value="atendimento">Atendimento</option>
                                <option value="chamado">Chamado</option>
                                <option value="tarefa">Tarefa</option>
                            </select>
                        </span>

                        <span>
                            <label htmlFor="prioridadeNonaTarefa">Prioridade</label>
                            <select id='prioridadeNonaTarefa' value={prioridade} onChange={(e) => setPrioridade(e.target.value)} required>
                                <option value=""></option>
                                <option value="urgente">Urgente</option>
                                <option value="alta">Alta</option>
                                <option value="baixa">Baixa</option>
                            </select>
                        </span>

                        {!tarefa && <span>
                            <label htmlFor="dataEntrega">Data da Entrega</label>
                            <input
                                id='dataEntrega'
                                type='date'
                                value={dataEntrega}
                                onChange={(e) => setDataEntrega(e.target.value)}
                                required />
                        </span>}

                        {tarefa && <span>
                            <label htmlFor="situacaoTarefa">Situacao</label>
                            <select id='situacaoTarefa' value={situacao} onChange={(e) => setSituacao(e.target.value)} required disabled={!!tarefa?.idUsuarioAprovador && usuarioLogado !== tarefa.idUsuarioAprovador}>
                                <option value="pendente">Pendente</option>
                                <option value="atrasada">Atrasada</option>
                                <option value="concluída">Concluída</option>
                            </select>
                        </span>}
                    </section>

                    <section>
                        <span>
                            <label htmlFor="tituloTarefa">Título</label>
                            <input
                                id='tituloTarefa'
                                value={titulo}
                                onChange={(e) => setTitulo(e.target.value)}
                                type='text'
                                maxLength={100}
                                required />
                        </span>
                        <span>
                            <label htmlFor="responsaveltarefa">Responsável</label>
                            <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)} required disabled={tarefa && (!!tarefa.idUsuarioAprovador && tarefa.idUsuarioAprovador !== usuarioLogado)}>
                                <option value=""></option>
                                {resposaveis.map((responsavel) => (
                                    <option key={responsavel.usuario.id} value={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                                ))}
                            </select>
                        </span>
                    </section>

                    <div className='opcoesTarefasContainer'>
                        <label className='opcoesTarefasLabel' htmlFor="descricaoTarefa" onClick={() => exibirOpcoestarefas('descricao')}>Descrição da Tarefa</label>
                        {tarefa && <label className='opcoesTarefasLabel' htmlFor="subTarefaTarefa" onClick={() => exibirOpcoestarefas('subtarefas')}>SubTarefas</label>}
                        {tarefa && <label className='opcoesTarefasLabel' htmlFor="tarefasComentarios" onClick={() => exibirOpcoestarefas('comentarios')}>Comentários</label>}
                        {tarefa && <label className='opcoesTarefasLabel' htmlFor="tarefasAnexos" onClick={() => exibirOpcoestarefas('anexos')}>Anexos</label>}
                        {!tarefa && <label className='opcoesTarefasLabel' htmlFor="subTarefaTarefa" onClick={() => exibirOpcoestarefas('subtarefasLocal')}>SubTarefas</label>}
                        <label className='opcoesTarefasLabel' htmlFor="inicioAutomacao" onClick={() => exibirOpcoestarefas('automacao')}>Automação</label>
                        {tarefa && <label className='opcoesTarefasLabel' htmlFor="subTarefaTarefa" onClick={() => exibirOpcoestarefas('resultado')}>Resultado</label>}
                        {(!tarefa || (tarefa && (usuarioLogado === tarefa.idUsuarioAprovador || !tarefa.idUsuarioAprovador))) && <label className='opcoesTarefasLabel' htmlFor="inicioAutomacao" onClick={() => exibirOpcoestarefas('aprovacao')}>Aprovação</label>}
                    </div>

                    {opcoesTarefas === 'descricao' && <section>
                        <span>
                            <textarea
                                id='descricaoTarefa'
                                name="descricaoTarefa"
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                placeholder='Descreva aqui o que precisará ser realizado nesta tarefa'
                                rows={10}
                                maxLength={500}
                                className='resize-none'
                                required />
                        </span>
                    </section>}

                    {opcoesTarefas === 'subtarefas' && <section className='subTarefasContainer'>
                        <p id='adicionarSubtarefasContent' onClick={() => cadastrarNovaSubTarefa()}>Adicionar Subtarefa</p>
                        <table id='tabelaListaContainer'>
                            <tbody>
                                {subTarefas.map((subtarefa) => (
                                    <tr key={Math.random()}>
                                        <td id='primeiraColuna' onClick={() => updateSubTarefa(subtarefa.id, subtarefa.finalizada)}>
                                            <input
                                                className='toggleSubTarefas'
                                                id={`toggleSubTarefas-${subtarefa.id}`}
                                                type="checkbox"
                                                readOnly
                                                checked={subtarefa.finalizada}
                                            />
                                            <label
                                                className='label-toggleSubTarefas'
                                                htmlFor={`toggleSubTarefas-${subtarefa.id}`}
                                            ></label>
                                        </td>
                                        <td>{subtarefa.descricao}</td>
                                        <td id='usuarioResponsavelTarefaContent'>
                                            <img id='usuarioResponsavelTarefa' src={subtarefa.finalizadoPor?.avatar} alt='' />
                                            <p>{subtarefa.finalizadoPor?.nome}</p>
                                        </td>
                                        <td id='ladoDireitoContent' align='center'>
                                            {subtarefa.finalizada === false && <img id='apagarIconeTarefa' title='Excluir SubTarefa' src={apagarImg} alt='' onClick={() => deleteSubTarefa(subtarefa.id)} />}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </section>}

                    {opcoesTarefas === 'subtarefasLocal' && <section className='subTarefasContainer'>
                        <p id='adicionarSubtarefasContent' onClick={() => adicionarSubTarefaLocal()}>Adicionar Subtarefa</p>
                        <table id='tabelaListaContainer'>
                            <tbody>
                                {subTarefasLocal.map((subtarefa, index) => (
                                    <tr key={index}>
                                        <td id='primeiraColuna'>{subtarefa.descricao}</td>
                                        <td id='ladoDireitoContent' align='right'>
                                            <img id='apagarIconeTarefa' title='Excluir SubTarefa' src={apagarImg} alt='' onClick={() => removerSubTarefaLocal(index)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </section>}

                    {tarefa && opcoesTarefas === 'comentarios' && <section>
                        <span>
                            <div className='tarefaComentarioContainer'>
                                <input
                                    type="text"
                                    placeholder='Digite seu comentário'
                                    onChange={(e) => setComentario(e.target.value)}
                                />
                                <Button type='button' cor='salvar' isLoading={processando} onClick={enviarComentario}>
                                    {!processando && 'Postar'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </div>
                            <br />
                            {comentarios.length > 0 && <p className='tarefasAnexos'>Comentários</p>}
                            <div className='comentarioTarefaContainer'>
                                {comentarios.map((comentario) => (
                                    <div className='comentarioTarefaContent' key={comentario.id}>
                                        <img src={comentario.usuario.avatar || avatarDefault} alt="" title={comentario.usuario.nome} />
                                        <p>{comentario.comentario}</p>
                                    </div>
                                ))}
                            </div>
                        </span>
                    </section>}

                    {tarefa && opcoesTarefas === 'anexos' && <section>
                        <span>
                            <div className='tarefaAnexarArquivoContainer'>
                                <input
                                    type="file"
                                    onChange={(e) => documentoSelecionado(e)}
                                />
                                <Button type='button' cor='salvar' isLoading={processando} onClick={anexarDocumento}>
                                    {!processando && 'Anexar Arquivo'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </div>
                            <br />
                            {anexos.length > 0 && <p className='tarefasAnexos'>Arquivos Anexados</p>}
                            <div className='anexosTarefaContainer'>
                                {anexos.map((arquivo) => (
                                    <div className='apagarAnexoContent'>
                                        <p className='tarefasAnexosLink' onClick={() => visualizarAnexoTarefa(arquivo.anexo)}>{nomeArquivo(arquivo.anexo)}</p>
                                        <span className='apagarAnexoUsuario'>
                                            <span>
                                                <img src={arquivo.usuario.avatar || avatarDefault} alt="" title={arquivo.usuario.nome} />
                                                <p>{arquivo.usuario.nome}</p>
                                            </span>
                                            {(perfilLogado === 'master' || usuarioLogado === arquivo.usuario.id) && <img src={apagarImg} alt='' title='Apagar Anexo' onClick={(e) => apagarAnexo(e, arquivo.id)} />}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </span>
                    </section>}

                    {tarefa && opcoesTarefas === 'resultado' && <section>
                        <span>
                            <textarea
                                className='resultadoTarefa'
                                id='resultadoTarefa'
                                name="resultadoTarefa"
                                value={resultado === null ? '' : resultado}
                                onChange={(e) => setResultado(e.target.value)}
                                placeholder='Qual foi a conclusão dessa tarefa'
                                rows={12} />
                        </span>
                    </section>}

                    {opcoesTarefas === 'automacao' && <div className='tarefasRecorrentes'>
                        <input
                            checked={automacao}
                            className='toggleAutomacaoTarefas'
                            id='automacaoRecorrencia'
                            type="checkbox"
                            onChange={() => setAutomacao(!automacao)} />
                        <label className='label-toggleAutomacaoTarefas' htmlFor='automacaoRecorrencia'></label>
                        <p>Recorrência</p>
                    </div>}
                    {automacao && opcoesTarefas === 'automacao' && <section className='automacaoTarefas'>
                        <span>
                            <label htmlFor="inicioAutomacao">Início da Automação</label>
                            <input
                                id='inicioAutomacao'
                                type='date'
                                value={inicioAutomacao}
                                onChange={(e) => setInicioAutomacao(e.target.value)}
                                required />
                        </span>
                        <span>
                            <label htmlFor="">Frequência</label>
                            <select value={recorrencia !== null ? recorrencia : ''} onChange={(e) => setRecorrencia(e.target.value)} required>
                                <option value=""></option>
                                <option value="diaria">Diária</option>
                                <option value="semanal">Semanal</option>
                                <option value="mensal">Mensal</option>
                                <option value="trimestral">Trimestral</option>
                                <option value="semestral">Semestral</option>
                                <option value="anual">Anual</option>
                            </select>
                        </span>
                        <span>
                            <label htmlFor="prazoAutomacao">Prazo</label>
                            <input
                                id='prazoAutomacao'
                                type='number'
                                value={prazo}
                                placeholder='Prazo em Dias'
                                onChange={(e) => setPrazo(parseInt(e.target.value))}
                                required />
                        </span>
                    </section>}

                    {opcoesTarefas === 'aprovacao' && <section>
                        <span>
                            <select id='responsaveltarefa' value={idUsuarioAprovador || ""} onChange={(e) => setIdUsuarioAprovador(e.target.value)}>
                                <option value="">Escolha um Usuário para aprovar a Tarefa</option>
                                {resposaveis.map((responsavel) => (
                                    <option key={responsavel.usuario.id} value={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                                ))}
                            </select>
                        </span>
                    </section>}

                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando}>
                            {!tarefa || !tarefa.idUsuarioAprovador || usuarioLogado === tarefa.idUsuarioAprovador
                                ? "Salvar Dados"
                                : "Enviar para Aprovação"
                            }
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalTarefas
